import React, { Component } from 'react';
import Flickity from 'react-flickity-component'
import ReactCursorPosition from 'react-cursor-position';
import Icon from "./js/src/LoaderIcon";
import { isMobile } from 'react-device-detect';

class Post extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentSlide: 0, 
            isEnd: false,
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth
        }; 
        this.updateCurrentSlide = this.updateCurrentSlide.bind(this);
        this.imageAspectRatio = this.imageAspectRatio.bind(this);
        this.updateWindowHeight = this.updateWindowHeight.bind(this);

        
        window.addEventListener("resize", this.updateWindowHeight);
    }

    componentDidMount = () => {
        this.flkty.on( 'select', () => {
            if (this.flkty.selectedIndex === this.flkty.cells.length - 1 && this.props.currentPost !== this.props.totalPosts-1) {
                this.setState({isEnd: true})
                this.props.endOfPostHandler();
            } else if(this.flkty.selectedIndex < this.flkty.cells.length - 1){
                this.setState({isEnd: false})
                this.props.endOfPostHandler(true);
            }
       })
        this.flkty.on('select', () => {
            this.updateCurrentSlide();
        })
        if(!isMobile){
            if(document.getElementsByClassName('carousel-status')[0] !== null || document.getElementsByClassName('carousel-status')[0] !== undefined) {
                document.getElementsByClassName('carousel-status')[0].style.display = "none"
                setTimeout(function(){
                    document.getElementsByClassName('carousel-status')[0].style.display = "block"
                }, 500);
            }
        }
    }

    updateCurrentSlide() {
        if(this.flkty.isActive){
            this.setState({
                currentSlide: this.flkty.selectedIndex + 1
            });
        }
    }

    //WINDOW HEIGHT 
    updateWindowHeight() {
        this.setState({ windowHeight: window.innerHeight, windowWidth:window.innerWidth });
    }

    imageAspectRatio(image){
        if(((this.state.windowHeight * 0.7) * (image.details.image.width / image.details.image.height)) < (this.state.windowWidth*0.8)) {
            return {
            width: (this.state.windowHeight * 0.7) * (image.details.image.width / image.details.image.height) + "px",
            height: (this.state.windowHeight * 0.7) + "px"
          }
        } else {
            if(image.details.image.height > image.details.image.width){
                return {
                    width: (this.state.windowWidth * 1.1) * (image.details.image.width / image.details.image.height) + "px",
                    height: (this.state.windowWidth * 1.1) + "px"
                }          
            } else {
                return {
                    width: (this.state.windowWidth * 0.6) * (image.details.image.width / image.details.image.height) + "px",
                    height: (this.state.windowWidth * 0.6) + "px"
                }  
            }

        }
      }   
    

    renderImage(imageUrl, i) {
        let img = imageUrl.fields.file.url+'?q=90&w=1400';
        return (
            <div className="gallery-cell" key={i}>
                <div className="galleryImg" style={this.imageAspectRatio(imageUrl.fields.file)}>
                    <img className="carousel-cell-image" src={imageUrl.fields.file.url+'?q=1&w=10'} data-flickity-lazyload-src={img} alt={imageUrl.fields.file.fileName} key={i}/>
                </div>
            </div>
          );
    }
    
    render() {
        const flickityOptions = {
            dragThreshold: 0,
            setGallerySize: false,
            pageDots: false,
            wrapAround: false,
            lazyLoad: 5
        }

        let currentSlide = 0;
        let totalSlides = 0

        if(this.flkty !== undefined){
            currentSlide = this.state.currentSlide
            totalSlides = this.flkty.slides.length
        }

        return (  
            <div className="gallery">
                <ReactCursorPosition>
                    <div className="gallery-inner">
                        <Flickity options={flickityOptions} flickityRef={c => this.flkty = c}>
                            {this.props.images.map( (imageUrl, i) => this.renderImage(imageUrl, i))}
                        </Flickity>       
                    </div>                  
                    { this.state.isEnd ? <SvgLabel /> : <PositionLabel currentSlide={currentSlide} totalSlides={totalSlides} title={this.props.postName} /> }
                 </ReactCursorPosition>
                 <div id="postCategory">{this.props.postCat}</div>
            </div>
        )
      }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowHeight);
        this.flkty.isActive = false;
        
    }
}

export default Post;

const PositionLabel = (props, data) => {
    const {
      currentSlide = 0,
      totalSlides = 0,
      position: {
        x = window.innerWidth / 2,
        y = window.innerHeight / 2,
      } = {}
    } = props;
    return (
      <div className="carousel-status" style={{top:y+10, left:x+10}}>
        <h2 className="title">{props.title} <span>{currentSlide} / {totalSlides}</span></h2>
      </div>
    );
};

const SvgLabel = (props) => {
    const {
        position: {
          x = 0,
          y = 0
        } = {}
      } = props;

      return (
        <div className="carousel-status-loader" style={{top:y+10, left:x+10}}> 
            <Icon />
        </div>
      );
}


// WEBPACK FOOTER //
// ./src/Post.js